/**
 * 封装统一的校验会员权益使用情况方法，便于在混入和一些非组件场景下使用
 */
import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
import { checkMemberBenefit } from '@/api/memberBenefit/index'

// 错误码与提示信息的映射(这块定义的提示信息不再使用)
// const ERROR_MSG_MAP = {
// 	6101: '用户暂未开通会员',
// 	6102: '当前用户会员等级权限不足',
// 	6103: '当前用户会员加油包次数已用完',
// 	6104: '当前用户会员权益已使用完，请等待会员权益重置后再使用'
// }

/**
 * 通用会员权益校验函数
 * @param {string} memberBenefit - 权益标识（来自 ENUM_MEMBER_BENEFIT）
 * @returns {boolean} - 是否通过校验（200时返回 true，其他返回 false）
 */
export async function checkMemberBenefitUsage(memberBenefit) {
	if (!Object.values(ENUM_MEMBER_BENEFIT).includes(memberBenefit)) {
		console.error('无效的会员权益标识:', memberBenefit)
		return false
	}

	try {
		const params = {
			memberBenefit,
			memberType: 'DEFAULT' // 固定值可统一管理
		}
		const { code, message } = await checkMemberBenefit(params)

		if (code !== 200) {
			// 统一处理错误提示
			// const msg = ERROR_MSG_MAP[code] || `未知错误码: ${code}`
			this.$modal.msgWarning(message) // 若在组件外调用，需传入 $modal 实例
			return false
		}
		return true
	} catch (error) {
		console.error('权限校验失败:', error)
		this.$modal.msgError('系统异常，请稍后重试') // 统一处理异常
		return false
	}
}
